import axios from 'axios'
import Cookies from 'universal-cookie'

const COOKIES = new Cookies()
export const TOKEN = COOKIES.get('tokenSASSafecash')

export const URL_SERVER = process.env.REACT_APP_URL_SERVER
export const URL_SERVER_KYC = process.env.REACT_APP_URL_SERVER_KYC
export const API_VERIFY = `${URL_SERVER}/api/kyc/users`

const CONFIG = {
  headers: {
    'X-Access-Token': TOKEN,
  },
}

export function BACK_TO_LOGIN() {
  COOKIES.remove('tokenSASSafecash', { path: '/' })
  COOKIES.remove('usernameSASSafecash', { path: '/' })
  window.location.href = '/'
}

// For handle 401 status
axios.interceptors.response.use(
  response => response,
  (err) => {
    if (err.response && err.response.status === 401) {
      BACK_TO_LOGIN()
    }
    return Promise.reject(err)
  },
)

export function API_USER_LOGIN(param) {
  const API_LOGIN = `${URL_SERVER}/api/auth/token`
  return axios.post(API_LOGIN, param)
}

export const API_GET_ORDERS = (query) => {
  const API_ENDPOINT_GET_ORDERS = `${URL_SERVER}/orders`
  return axios.get(API_ENDPOINT_GET_ORDERS, { ...CONFIG, params: query })
}

export const API_EDIT_ORDER_STATUS = (orderId, data) => {
  const API_ENDPOINT_EDIT_ORDER_STATUS = `${URL_SERVER}/orders/${orderId}/setStatus`
  return axios.post(API_ENDPOINT_EDIT_ORDER_STATUS, data, CONFIG)
}

export const API_EDIT_ORDER_STATUS_READYTOREFUND = (orderId, data) => {
  const API_ENDPOINT_EDIT_ORDER_STATUS_REFUND = `${URL_SERVER}/orders/${orderId}/refund`
  return axios.post(API_ENDPOINT_EDIT_ORDER_STATUS_REFUND, data, CONFIG)
}

export const API_GET_ORDER = (orderId) => {
  const API_ENDPOINT_GET_ORDER = `${URL_SERVER}/orders/${orderId}`
  return axios.get(API_ENDPOINT_GET_ORDER, CONFIG)
}

export const API_GET_USERS = (userId, params) => {
  const USER_ID = userId || ''
  const API_USERS = `${URL_SERVER}/api/users/${USER_ID}`
  return axios.get(API_USERS, { ...CONFIG, params })
}

export const API_GET_USER_DEVICES = (userId) => {
  const USER_ID = userId || ''
  const API_USERS = `${URL_SERVER}/api/users/${USER_ID}/device`
  return axios.get(API_USERS, CONFIG)
}

export const API_FORCE_LOGOUT = (userId) => {
  const USER_ID = userId || ''
  const API_USERS = `${URL_SERVER}/api/users/${USER_ID}/logout`
  return axios.patch(API_USERS, {}, CONFIG)
}

export const API_RANDOM_PASSWORD = (userId) => {
  const USER_ID = userId || ''
  const API_USERS = `${URL_SERVER}/api/users/${USER_ID}/setRandomPassword`
  return axios.patch(API_USERS, {}, CONFIG)
}

export const API_USER_BLOCK = (userId, status) => {
  const USER_ID = userId || ''
  const API_USERS = `${URL_SERVER}/api/users/${USER_ID}/toggleBlock/${status}`
  return axios.patch(API_USERS, {}, CONFIG)
}

export const API_GET_USER_EVENTS = (userId, params) => {
  const USER_ID = userId || ''
  const API_USERS = `${URL_SERVER}/api/users/${USER_ID}/event`
  return axios.get(API_USERS, { ...CONFIG, params })
}


export const API_GET_USER_LOG = (userId) => {
  const USER_ID = userId || ''
  const API_USERS = `${URL_SERVER}/api/users/${USER_ID}/featureLog`
  return axios.post(API_USERS, {}, CONFIG)
}

export const API_GET_USER_DOC = (userId) => {
  const USER_ID = userId || ''
  const API_USERS = `${URL_SERVER_KYC}/api/kyc/users/${USER_ID}/groups`
  return axios.get(API_USERS, CONFIG)
}



// WEBPACK FOOTER //
// src/api/index.js